
interface Form {
  collocation: number;
  subcollocation: number;
  category: number;
  online_status: string;
}
import { Component, Vue } from 'vue-property-decorator';
import { STATUS_LIST } from '@/constants';
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/product`,
  collocation: `${FCAPI}/boss/ruan/collocation`,
  category: `${FCAPI}/boss/ruan/category`,
  online: `${FCAPI}/boss/ruan/product/onlinestatus`,
  sort: `${FCAPI}/boss/ruan/product/sort`,
};
@Component
export default class RuanProductList extends Vue {
  is_loading = false;
  form: Form = {
    collocation: 0,
    subcollocation: 0,
    category: 0,
    online_status: '0',
  };
  collocation_list = [];
  collocation_list_obj: any = {};
  subcollocation_list = [];
  subcollocation_list_obj: any = {};
  status_list = STATUS_LIST;
  category_list = [];
  category_list_obj: any = {};
  table_data = {};
  page = 1;

  handChangePaging(pagination: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  async onChangeSort(item: any) {
    const res = await this.$axios.put(`${API.sort}/${item.id}`, {
      id: item.id,
      sort: item.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('修改成功');
    await this.query(this.page);
  }

  async onChangeOnlineStatus(item: any) {
    const res = await this.$axios.put(`${API.online}/${item.id}`, {
      id: item.id,
      online_status: item.online_status === 1 ? 5 : 1,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.query(this.page);
  }

  onSelectCollocation(value: any) {
    this.form.subcollocation = 0;
    const subcollocation = this.collocation_list.filter((item: any) => {
      return item.id === value;
    });
    this.subcollocation_list = subcollocation[0]
      ? (subcollocation[0] as any).sub
      : [];
    this.subcollocation_list.forEach((item: any) => {
      this.subcollocation_list_obj[item.id] = item.name;
    });
  }

  submit() {
    this.query(1);
  }

  async query(page = 1) {
    this.page = page;
    const form = this.form;
    const send_data = {
      current: page,
      collocation_id: form.collocation || '',
      collocation_sub_id: form.subcollocation || '',
      category_id: form.category || '',
      online_status:
        form.online_status === 'on' ? 1 : form.online_status === 'off' ? 5 : '',
    };
    const res = await this.$axios.get(API.query, { params: send_data });
    if (res.data.status !== 200) {
      this.table_data = {};
      return;
    }
    const data = res.data.data || {};
    this.table_data = data;
  }

  clearForm() {
    const form = this.form;
    form.collocation = 0;
    form.subcollocation = 0;
    form.category = 0;
    form.online_status = '0';
  }

  async getCollocation() {
    const res = await this.$axios.get(API.collocation);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.collocation_list = data;
    this.collocation_list.forEach((item: any) => {
      this.collocation_list_obj[item.id] = item.name;
    });
  }

  async getCategory() {
    const res = await this.$axios.get(API.category);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.category_list = data;
    this.category_list.forEach((item: any) => {
      this.category_list_obj[item.id] = item.name;
    });
  }

  async created() {
    await this.getCollocation();
    await this.getCategory();
    await this.query(1);
  }
}
